export default __webpack_public_path__ + "static/media/pending.c13aebbf.svg";